import "./LoadingScreen.scss";

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loader">
        <img src="/images/Loader-2.gif" alt="Loading..." />
      </div>
    </div>
  );
};

export default LoadingScreen;
